import React, { useEffect, useState, useContext } from 'react'
import { i18nContext } from '../i18n/i18nContext';
import { Processing } from '../Common/Processing';
import { ProcessError } from '../Common/ProcessError';
import { FormInputType, KaguWorkForm } from '../Pages/KaguWorkForm';
import { KaguWorkConfirm } from '../Pages/KaguWorkConfirm';
import { KaguWorkComplete } from '../Pages/KaguWorkComplete';
import { KaguWorkRegistered } from '../Pages/KaguWorkRegistered';
import { KaguWorkTimeout } from '../Pages/KaguWorkTimeout';

import { useMailData } from '../DataFetch/useMailData';
import { useCountryData } from '../DataFetch/useCountryData';

/**
 * ページ名オブジェクト
 * ページを指定するときに使用
 */
export const PageNames = {    
    KaguWorkForm: "KaguWorkForm",
    KaguWorkConfirm: "KaguWorkConfirm",
    KaguWorkComplete: "KaguWorkComplete",
    KaguWorkRegistered: "KaguWorkRegistered",
    KaguWorkTimeout: "KaguWorkTimeout",
    Processing: "Processing",
    ProcessError: "ProcessError",
}

/**
 * ブラウザのウインドウ名に表示する内容
 */
const PageTitles:{[pageName: string]: string} = {
    "KaguWorkForm":"KAGUデザインコンペ 作品登録",
    "KaguWorkConfirm":"KAGUデザインコンペ 作品登録確認",
    "KaguWorkComplete":"KAGUデザインコンペ 作品登録完了",
    "KaguWorkRegistered":"KAGUデザインコンペ 作品登録済み",
    "KaguWorkTimeout":"KAGUデザインコンペ 作品登録タイムアウト",
    "Processing":"処理中",
    "ProcessError":"通信エラー"
}

/**
 * ページContextの型
 */
type PageContextType = {
    setPage: (page: string) => void,
    page: string,
}

/**
 * ページContextページ名、ページ変更関数を各ページに渡す
 */
export const PageContext = React.createContext<PageContextType>({} as PageContextType)

/**
 * 作品登録のRoot関数
 * ここから各ページに分岐する。
 */
export function HomeWork() {

    const {setLng} = useContext(i18nContext);

    const [page, setPage] = useState<string>(PageNames.Processing);

    /**
     * メール登録情報を取得
     */
    const {MailData, isLoadingMailData} = useMailData(new URLSearchParams(window.location.search).get("id"))

    /**
     * 国マスタ
     */
    const {CountryData, isLoadingCountryData} = useCountryData()

    const [formData, setFormData] = useState<FormInputType | undefined>(undefined)

    const Pages: Record<string, JSX.Element> = {
        "KaguWorkForm": <KaguWorkForm 
                            MailData={MailData} 
                            CountryData={CountryData}
                            formData={formData}
                            setFormData={setFormData}
                        />,
        "KaguWorkConfirm": <KaguWorkConfirm formData={formData} CountryData={CountryData}/>,
        "KaguWorkComplete": <KaguWorkComplete/>,
        "KaguWorkRegistered": <KaguWorkRegistered/>,
        "KaguWorkTimeout": <KaguWorkTimeout/>,        
        "Processing": <Processing/>,
        "ProcessError": <ProcessError pageName={formData !== undefined ? PageNames.KaguWorkConfirm : ""} setPage={setPage}/>,
    }

    /**
     * ページ変更時処理
     */
    useEffect(() => {
        //ページタイトル変更
        document.title = PageTitles[page];

        //前のページ情報を記録
        if (page !== PageNames.ProcessError)

        //スクロール位置を一番上に戻す
        window.scrollTo(0, 0);
    },[page])

    useEffect(() => {
        if (!isLoadingMailData && !isLoadingCountryData) {
            switch (MailData.state) {
                case 1:
                    setPage(PageNames.KaguWorkForm)
                    break;
                case 2:
                    setPage(PageNames.KaguWorkRegistered)
                    break;
                case 3:
                    setPage(PageNames.KaguWorkTimeout)
                    break;
                default:
                    setPage(PageNames.ProcessError)
                    break;
            }       
            
            setLng(MailData.language)
        }
    },[isLoadingMailData, isLoadingCountryData, MailData, setLng])

    return(
        <>
            <PageContext.Provider value={{page, setPage}}>
                {!isLoadingMailData && !isLoadingCountryData && Pages[page]}
            </PageContext.Provider>
        </>
    );
}